export const LOCAL_STORAGE_FORM_KEY = 'extractionFieldsForm';
export const PROPERTY_AI_EXTRACTION_FIELD_CONFIDENCE_THRESHOLD =
  'AiExtractionFieldConfidenceThreshold';
